import dictag from './dictag.vue';
import copy from './copy.vue';
import selectes from './selectes.vue';

dictag.copy = copy;
dictag.selectes = selectes;
export default dictag;


// WEBPACK FOOTER //
// ./src/components/inc/dictionary/index.js